export const NavigationMode = {
  hero: "hero",
  navbar: "navbar",
  transparent: "transparent",
} as const;

export const NavigationTheme = {
  light: "light",
  dark: "dark",
} as const;

export type NavigationModeType =
  (typeof NavigationMode)[keyof typeof NavigationMode];
export type NavigationThemeType =
  (typeof NavigationTheme)[keyof typeof NavigationTheme];
